module.exports = __webpack_public_path__ + "img/wiffle_ninja_logo_v1.40d95eaf.png";